import Address from './Address.vue';
import Index from './Index.vue';
import Options from './Options';
import Confirmation from './Confirmation';
import OrderConfirmation from './OrderConfirmation';
import Passengers from './Passengers';
import PaymentError from './PaymentError';
import Summary from './Summary';
import Vehicles from './Vehicles';

export default { Index, Address, Options, Confirmation, OrderConfirmation, Passengers, PaymentError, Summary, Vehicles };
